import { useEffect, useContext } from 'react';

import { PageContext, ModuleContext } from '../../context';

const useMainPageLoadModule = () => {
  const { pageContext } = useContext(PageContext);
  const { moduleContext } = useContext(ModuleContext);

  useEffect(() => {
    pageContext?.setModuleLoaded && moduleContext?.moduleType && pageContext?.setModuleLoaded(moduleContext.moduleType);
  }, [moduleContext?.moduleType]);

  return null;
};

export default useMainPageLoadModule;
